import type { SendEventForHits } from 'instantsearch.js/cjs/lib/utils';

export type SendHitsEvent = SendEventForHits;

export const HITS_TYPES = {
  VIDEO: 'Video modules',
  PATHWAY: 'Pathways',
  NEWS: 'Insights',
  GLOSSARY: 'Glossary',
};

export const HITS_TYPES_BY_URL = {
  search: '',
  videos: HITS_TYPES.VIDEO,
  pathways: HITS_TYPES.PATHWAY,
  insights: HITS_TYPES.NEWS,
  glossary: HITS_TYPES.GLOSSARY,
};

export const GLOBAL_TENANT = 'GLOBAL';

export const LIST_VIEW = 'list';
export const GRID_VIEW = 'grid';

export enum PATHWAY_ACTIONS {
  CONTINUE_WATCHING = 'continue_watching',
  TAKE_TEST = 'take_test',
  WATCH_AGAIN = 'watch_again',
  PASSED_TEST = 'passed_test',
  WATCH_NEW_CONTENT = 'watch_new_content',
}

export const calculatePathwayStatus = (
  watchedVideos: number,
  totalVideos: number,
  hash?: string | null,
  testId?: number | null,
): PATHWAY_ACTIONS => {
  const watchedAllVideos = watchedVideos === totalVideos;
  if (hash && watchedAllVideos) {
    return PATHWAY_ACTIONS.PASSED_TEST;
  } else if (hash && !watchedAllVideos) {
    return PATHWAY_ACTIONS.WATCH_NEW_CONTENT;
  } else if (testId && watchedAllVideos) {
    return PATHWAY_ACTIONS.TAKE_TEST;
  } else if (watchedAllVideos) {
    return PATHWAY_ACTIONS.WATCH_AGAIN;
  } else {
    return PATHWAY_ACTIONS.CONTINUE_WATCHING;
  }
};

export const DURATION_FILTER = 'duration_interval';
export const DURATION_FILTER_ORDER = [
  '0 - 15 minutes',
  '15 - 60 minutes',
  '1 - 2 hours',
  '3 - 4 hours',
  '4 hours +',
];

export enum FILTERS {
  Expert = 'user',
  Duration = 'duration_interval',
  Difficulty = 'difficulty.title',
  SearchType = 'searchable_type',
  Letter = 'letter_index',
  Category = 'categories.lvl0',
  Subcategory = 'categories.lvl1',
}

export type AggregatorHit = {
  id: number;
  searchable_type: string;
  title?: string;
  name?: string;
  slug?: string;
  description?: string;
  duration?: number;
  duration_interval?: string;
  user?: string;
  executive_summary?: string;
  key_learning_objectives?: string;
  categories?: {
    lvl0?: string[];
    lvl1?: string[];
  };
  difficulty?: {
    id?: number;
    title?: string;
    icon_url?: string;
  };
  preview_url?: string;
  image_url?: string;
  video_url?: string;
  user_slug?: string;
  categories_array?: [
    id?: number,
    title?: string,
    slug?: string,
    parent?: {
      id?: number;
      slug?: string;
    },
  ];
  count_videos?: number;
  cpd_credits?: number;
  post_content?: string;
  post_introduction?: string;
  published_at?: number;
  category?: string;
  letter_index?: string;
  subtitle?: string;
  definition?: string;
  content?: string;
  updated_at?: number;
};
